export const ORGANIZATION_TYPES = [
    {
        label: "Registered Energy Advisors",
        value: "registeredEnergyAdvisors",
    },
    {
        label: "Service Organization",
        value: "serviceOrganization",
    },
    {
        label: "HVAC Designers / Technicians",
        value: "hvacDesignersTechnicians",
    },
    {
        label: "Engineers",
        value: "engineers",
    },
    {
        label: "Architects",
        value: "architects",
    },
    {
        label: "Researchers",
        value: "researchers",
    },
    {
        label: "University / College",
        value: "universityCollege",
    },
    {
        label: "Consultants",
        value: "consultants",
    },
    {
        label: "Other",
        value: "other",
    },
];
